import { ElementType, Suspense } from "react";

// project-imports
// import Loader from './Loader';
import CircularLoader from "./CircularLoader";

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<CircularLoader />}>
      <Component {...props} />
    </Suspense>
  );

export default Loadable;
